import React, { PureComponent } from 'react';
import ReactTooltip from 'react-tooltip';

import { T } from '../../../../common/locale/translate';

class DepartureFromGermany extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      opened: false
    };
  }

  render() {
    return (
      <div className="departure-from-germany-info">
        <img
          className="question-mark"
          src="/img/icons/question_mark.svg"
          alt={T('why_with_german_operator_alt')}
          onClick={this.togglePopupVisibility}
          data-tip
          data-for={this.props.tooltip_id}
        />
        <ReactTooltip
          id={this.props.tooltip_id}
          place="top"
          type="light"
          effect="solid"
          delayHide={300}
        >
          <div className={`popup${this.state.opened ? ' opened' : ''}`}>
            <article
              ref={r => {
                this.popupContent = r;
              }}
              className="content"
            >
              <header>
                <h1>{T('why_holidays_with_german_operator')}</h1>
                <img
                  className="close-btn"
                  src="/img/icons/x_icon.svg"
                  alt={T('close')}
                  onClick={this.togglePopupVisibility}
                />
              </header>
              <ul>
                <li>{T('lower_prices')}</li>
                <li>{T('better_rooms')}</li>
                <li>{T('better_safety')}</li>
                <li>{T('always_consistent')}</li>
                <li>{T('more_destinations_and_dates')}</li>
              </ul>
            </article>
          </div>
        </ReactTooltip>
      </div>
    );
  }

  togglePopupVisibility = () => {
    const isOpened = this.state.opened;
    this.setState(
      {
        opened: !isOpened
      },
      () => {
        isOpened ? this.removeListener() : this.attachListener();
      }
    );
  };

  handleClickOutside = e => {
    const isClickedPopupContent =
      e.target &&
      (e.target === this.popupContent || this.popupContent.contains(e.target));
    if (!isClickedPopupContent) {
      this.togglePopupVisibility();
    }
  };

  attachListener = () => {
    document.addEventListener('click', this.handleClickOutside);
  };

  removeListener = () => {
    document.removeEventListener('click', this.handleClickOutside);
  };
}

DepartureFromGermany.defaultProps = {
  tooltip_id: 'departure-from-germany-tooltip'
};

export default DepartureFromGermany;



// WEBPACK FOOTER //
// ./app/javascript/common/components/departure_from_germany.jsx